import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
export var viewActions;
(function (viewActions) {
    viewActions["REQUEST"] = "VIEW_ACTION_REQUEST";
    viewActions["SUCCESS"] = "VIEW_ACTION_SUCCESS";
    viewActions["ERROR"] = "VIEW_ACTION_ERROR";
})(viewActions || (viewActions = {}));
// Documentation - https://docs.google.com/document/d/15OzI1IxEHR2aGkNTqMgDyuJqABY9cxmGLwXWQjGxY58/edit?usp=sharing
export function fetchActionView(requestParams) {
    return (dispatch) => {
        dispatch({
            type: viewActions.REQUEST
        });
        const baseAjaxObj = Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/action/view',
            acceptErrors: true,
            action: viewActions.REQUEST
        });
        const reqObj = { actionRequestContext: requestParams };
        return ApiCaller.post(baseAjaxObj, reqObj).then(json => dispatch({
            type: viewActions.SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: viewActions.ERROR,
                error
            });
        });
    };
}
